module.exports = global["$"] = require("-!/static/node_modules/imports-loader/index.js?jQuery=jquery,$=jquery,this=>window!/static/node_modules/babel-loader/lib/index.js??ref--1!/static/node_modules/babel-loader/lib/index.js??ref--1!./jquery.js");


//////////////////
// WEBPACK FOOTER
// /static/node_modules/expose-loader?$!/static/node_modules/imports-loader?jQuery=jquery,$=jquery,this=>window!/static/node_modules/babel-loader/lib??ref--1!/static/node_modules/jquery/dist/jquery.js-exposed
// module id = 3O659FBd
// module chunks = vendors.common